import { newApiInstance, oldApiInstance } from 'functions/request';

export const fetchWithdrawalStatusApi = () => oldApiInstance.get('/plus/get_withdrawal_state');

export const fetchCategoriesApi = () => newApiInstance.get('/gift_cards/categories');

// last_product_id=SOME_ID -- id of the last product received from previous response, null on empty
// limit=20 -- between 10 and 50 max
// categories=beauty-and-lifestyle,booksellers,department-stores -- optional, if user selected any categories - send their codes
// popular_only=false
export const fetchGiftCardsApi = params => newApiInstance.get('/gift_cards/search', { params });
